/**
 * Collection of locale-specific utility functions on client-side When
 * constructor is called, locale (and BiDi config) is retrieved from <html> and
 * set as members of this module.
 */
define([], function() {
	var _singletonInstance = null;

	var LocaleUtil = null;
	LocaleUtil = function() {
		// Singleton
		if (LocaleUtil.prototype._singletonInstance) {
			return LocaleUtil.prototype._singletonInstance;
		}

		this.locale = this.getLocale();
		this.isRTL = this.isLocaleRTL(this.locale);

		LocaleUtil.prototype._singletonInstance = this;
	};

	/**
	 * Returns the user locale set to <html> lang attribute from server-side.
	 * This locale is matched from the supported locales and user's locale
	 * preference
	 * @return {string} Language code (e.g. en_CA)
	 */
	LocaleUtil.prototype.getLocale = function() {
		if (!this.locale) {
			this.locale = document.documentElement.getAttribute('lang');
		}
		return this.locale;
	};

	/**
	 * Checks if the locale passed in as the argument is a RTL (Right-to-Left)
	 * language
	 * @param  {string}  sLocale - Language code
	 * @return {boolean} True, if the locale is RTL
	 */
	LocaleUtil.prototype.isLocaleRTL = function(sLocale) {
		if (!this.isRTL) {
			var aRtlLocales = ['ar', 'he'];
			this.isRTL = aRtlLocales.indexOf(sLocale) >= 0;
		}
		return this.isRTL;
	};

	var _static = {
		getInstance: function() {
			if (!_singletonInstance) {
				_singletonInstance = new LocaleUtil();
			}
			return _singletonInstance;
		}
	};

	return _static.getInstance();
});
